import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
  getCommodexBudgetRatios,
  setCommodexBudgetRatio,
  SetCommodexBudgetRatioParams,
  CommodexBudgetRatio,
  getCommodexBudgetPrices,
  setCommodexBudgetPrice,
  SetCommodexBudgetPriceParams,
  CommodexBudgetPrice,
} from '../services/commodexService';

export function useCommodexBudgetRatios(accountId: number | undefined) {
  return useQuery<CommodexBudgetRatio[]>(
    ['commodex-budget-ratios', accountId],
    () => getCommodexBudgetRatios(accountId!),
    { enabled: !!accountId, staleTime: 30000, refetchOnWindowFocus: false },
  );
}

export function useSetCommodexBudgetRatio(accountId: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation(
    (params: SetCommodexBudgetRatioParams) => setCommodexBudgetRatio(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['commodex-budget-ratios', accountId]);
      },
    },
  );
}

export function useCommodexBudgetPrices(accountId: number | undefined) {
  return useQuery<CommodexBudgetPrice[]>(
    ['commodex-budget-prices', accountId],
    () => getCommodexBudgetPrices(accountId!),
    { enabled: !!accountId, staleTime: 30000, refetchOnWindowFocus: false },
  );
}

export function useSetCommodexBudgetPrice(accountId: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation(
    (params: SetCommodexBudgetPriceParams) => setCommodexBudgetPrice(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['commodex-budget-prices', accountId]);
      },
    },
  );
}
